import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class ProductLogisticGroup extends BaseEntity{
    
    productLogisticGroupCode : string;
    name : string;
    rank : number;

}